module.exports = __webpack_public_path__ + "img/qr-design.304a4095.png";